import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import React, { useRef, useState } from 'react';
import BannerForm, { BannerFormRef, BannerFormValues } from './BannerForm';
import { IBanner } from '@nxsys/types/models/banner';

type EditBannerModalProps = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (params: BannerFormValues) => Promise<void>;
  data: IBanner;
};

const EditBannerModal: React.FC<EditBannerModalProps> = ({
  isOpen,
  toggle,
  onSubmit,
  data,
}) => {
  const { messages } = useTypedIntl();
  const formRef = useRef<BannerFormRef>(null);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values: BannerFormValues) => {
    try {
      setIsSubmitting(true);
      await onSubmit(values);
      formRef.current?.reset();
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AppModalContainer
      title={messages['company.banner.edit']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.save'],
          buttonType: 'primary',
          onClick: () => formRef.current?.submit(),
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
      minHeight="200px"
    >
      <BannerForm
        formRef={formRef}
        onSubmit={handleSubmit}
        defaultValues={{
          summary: data.summary,
          startAt: data.startAt,
          endAt: data.endAt,
          mobileBackgroundImageUrl: data.mobileBackgroundImageUrl,
          isActive: data.isActive,
        }}
        type="edit"
      />
    </AppModalContainer>
  );
};

export default EditBannerModal;
